import { createWebHistory, createRouter } from "vue-router"; 
import Home from "@/views/Home.vue";

const routes = [ 
    { path: "/", name: "Home", component: Home, },
    { path: "/about", name: "About", component: () => import(/* webpackChunkName: 'about' */ '../views/About.vue'), }, 
    { path: "/magnet", name: "MagnetScan", component: () => import(/* webpackChunkName: 'magnetscan' */ '../views/MagnetScan.vue'), },
    { path: '/:pathMatch(.*)*', name: "NotFound", redirect: { name: "Home" } }
]; 

const router = createRouter({ history: createWebHistory(), routes, }); 

export default router;